module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study-pm"
  }, [_c('navigation'), _vm._v(" "), _c('div', {
    ref: "scrollZone",
    staticClass: "case-study__scroll-zone"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    ref: "contentBackground",
    staticClass: "case-study-content-background"
  }, [_c('div', {
    ref: "content",
    staticClass: "case-study__content case-study__row"
  }, [_c('div', {
    ref: "infos",
    staticClass: "case-study__infos"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "case-study__pepsi"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "case-study__photo-background-container"
  }, [_c('div', {
    staticClass: "case-study__photo-background"
  }), _vm._v(" "), _c('img', {
    ref: "game",
    staticClass: "case-study__img case-study__img-cap",
    attrs: {
      "src": "/static/assets/imgs/case-study/pepsi/181q62u.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "case-study__line case-study__row"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "case-study__half-block"
  }, [_c('div', {
    staticClass: "case-study__screen-circle"
  }, [_c('img', {
    ref: "can",
    staticClass: "case-study__photo",
    attrs: {
      "src": "/static/assets/imgs/case-study/pepsi/Pepsi_MAX_Cherry_16.png",
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('case-study-video', {
    staticClass: "case-study__row case-study__video-row"
  }, [_c('source', {
    attrs: {
      "src": "/static/assets/videos/case-study/pepsi/video.mp4",
      "type": "video/mp4"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "case-study__line case-study__row-button"
  }, [_c('div', {
    staticClass: "case-study__photo-background"
  }), _vm._v(" "), _c('link-button', {
    attrs: {
      "url": "http://img.mediaplex.com/content/0/0/ActiveLink_jsonly.htm?id=29110-213608-17922-1&ad_url=http://adfarm.mediaplex.com/ad&mpcr=57266411&mpcrset=root",
      "text": "play the demo"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "case-study__text-content-button"
  }, [_vm._v("(turn off any adblockers)")])], 1)], 1)])]), _vm._v(" "), _vm._l((_vm.nextButtons), function(nextButton) {
    return _c('next-button', {
      key: nextButton.to,
      attrs: {
        "title": nextButton.title,
        "to": nextButton.to
      }
    })
  })], 2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__photo-background-container"
  }, [_c('div', {
    staticClass: "case-study__hero-title"
  }, [_vm._v("\n        Pepsi Max\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__info"
  }, [_c('div', {
    staticClass: "case-study__info__title"
  }, [_vm._v("Context")]), _vm._v(" "), _c('div', {
    staticClass: "case-study__info__text"
  }, [_vm._v("Conversant")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__info"
  }, [_c('div', {
    staticClass: "case-study__info__title"
  }, [_vm._v("Role")]), _vm._v(" "), _c('div', {
    staticClass: "case-study__info__text"
  }, [_vm._v("Front-End Development")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__info"
  }, [_c('div', {
    staticClass: "case-study__info__title"
  }, [_vm._v("Period")]), _vm._v(" "), _c('div', {
    staticClass: "case-study__info__text"
  }, [_vm._v("2015")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__row case-study__section"
  }, [_c('div', {
    staticClass: "case-study__section-title"
  }, [_vm._v("Summary")]), _vm._v(" "), _c('div', {
    staticClass: "case-study__text-content"
  }, [_vm._v("\n              The Pepsi Max unit features a game of falling cans. Every can clicked grants two points, while clicking a red cherry blast Pepsi Max can grants bonus points. The more cans clicked, the faster the cans fall.\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__half-block"
  }, [_c('div', {
    staticClass: "case-study__section-title"
  }, [_vm._v("Technology Stack")]), _vm._v(" "), _c('div', {
    staticClass: "case-study__text-content"
  }, [_c('ul', [_c('li', [_vm._v("• JavaScript (Internal Framework)")]), _vm._v(" "), _c('li', [_vm._v("• GreenSock Animation Platform")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10cde4d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pepsi.vue
// module id = 170
// module chunks = 1